import React, { useState, useEffect } from 'react'
import { Button, Col, Space, Form } from 'antd'
import { successNotification, putRequest, carTasksUrl } from '../../config'
import TextAreaInput from '../../components/Forms/TextAreaInput'
import SelectInput from '../../components/Forms/SelectInput'
import BasicInput from '../../components/Forms/BasicInput'
import WithData from 'hocs/WithData'
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min'
import { CAR_VENDORS } from 'app-constants'
import PropTypes from 'prop-types'

const CarTaskUpdate = props => {
  const { task } = props
  const [payload, setPayload] = useState({
    type: task?.type || '',
    carUrl: task?.carUrl || '',
    retries: task?.retries || 0,
    rawHtml: task?.rawHtml || '',
    provideRawHtml: !!task?.rawHtml
  })
  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (task) {
      setPayload({
        type: task.type || '',
        carUrl: task.carUrl || '',
        retries: task.retries || 0,
        rawHtml: task.rawHtml || '',
        provideRawHtml: !!task.rawHtml
      })
    }
  }, [task])

  const handleInputChange = stateName => event => {
    setPayload({ ...payload, [stateName]: event.target.value })
  }

  const handleSelect = stateName => value => {
    setPayload({
      ...payload,
      [stateName]: value
    })
  }

  const handleUpdate = async event => {
    event.preventDefault()

    const response = await putRequest(
      `${carTasksUrl}/${task.id}`,
      {
        ...payload,
        rawHtml: payload.provideRawHtml ? payload.rawHtml : null
      },
      'car task',
      setLoading
    )

    if (response.success) {
      successNotification('Car Task Updated')
      props.handleCancel(response.data)
    } else {
      if (response.error.response) {
        setServerErrors(response.error.response.data)
      }
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div
              className="row"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <div className="col-md-5">
                <SelectInput
                  placeholder="select"
                  label="Car Dealer"
                  name="type"
                  value={payload.type}
                  onChange={handleSelect('type')}
                  optionList={CAR_VENDORS}
                  required={false}
                />
                {serverErrors.type &&
                  serverErrors.type.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <TextAreaInput
                  label="Car URL"
                  value={payload.carUrl}
                  name={'carUrl'}
                  placeholder="carUrl"
                  handleChange={handleInputChange('carUrl')}
                  required={true}
                />

                {serverErrors.carUrl &&
                  serverErrors.carUrl.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Number of Retries"
                  value={payload.retries}
                  name={'retries'}
                  placeholder="retries"
                  handleChange={handleInputChange('retries')}
                  required={false}
                />
                {serverErrors.retries &&
                  serverErrors.retries.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5 mt-4">
                <label>
                  <input
                    type="checkbox"
                    checked={payload.provideRawHtml}
                    onChange={e =>
                      setPayload({
                        ...payload,
                        provideRawHtml: e.target.checked
                      })
                    }
                  />{' '}
                  Provide Raw HTML manually?
                </label>
              </div>

              {payload.provideRawHtml && (
                <div className="col-md-12 mt-4">
                  <TextAreaInput
                    label="Raw HTML"
                    value={payload.rawHtml}
                    name={'rawHtml'}
                    placeholder="Paste the car's page source here"
                    handleChange={handleInputChange('rawHtml')}
                    required={true}
                  />
                  {serverErrors.raw_html &&
                    serverErrors.raw_html.map((err, i) => (
                      <div className="text-danger" key={i}>
                        {err}
                      </div>
                    ))}
                </div>
              )}

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    {/* eslint-disable-next-line react/prop-types */}
                    <Button onClick={() => props.handleCancel()}>Cancel</Button>
                    <Button
                      type="primary"
                      onClick={handleUpdate}
                      loading={loading}
                    >
                      Update
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

CarTaskUpdate.propTypes = {
  handleCancel: PropTypes.func,
  task: PropTypes.object
}

export default WithData(withRouter(CarTaskUpdate))
